import { useNavigate } from "react-router-dom";
export const EarningsRoutesComponent = () => {
	const navigate = useNavigate();
	const ArrayData = [
		// {
		// 	label: "List",
		// 	command: () => {
		// 		navigate("/payroll-earning/list");
		// 	},
		// },
		// {
		// 	label: "Setup",
		// 	command: () => {
		// 		navigate("/payroll-earning/setup");
		// 	},
		// },
		{
			label: "Payroll Earnings",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/payroll-earning/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/payroll-earning/setup");
					},
				},
			],
		},
		{
			label: "Assessable /WCB /WSIB",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/payroll-wcb-wsib-earning/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/payroll-wcb-wsib-earning/setup");
					},
				},
			],
		},
		{
			label: "CSST",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/payroll-csst-earning/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/payroll-csst-earning/setup");
					},
				},
			],
		},
		{
			label: "EHT",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/payroll-eht-earning/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/payroll-eht-earning/setup");
					},
				},
			],
		},
		{
			label: "Holiday Payable",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/payroll-holiday-earning/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/payroll-holiday-earning/setup");
					},
				},
			],
		},
		{
			label: "HSF",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/payroll-hsf-earning/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/payroll-hsf-earning/setup");
					},
				},
			],
		},
		{
			label: "Insurable",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/payroll-insurable-earning/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/payroll-insurable-earning/setup");
					},
				},
			],
		},

		{
			label: "Pensionable",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/payroll-pensionable-earning/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/payroll-pensionable-earning/setup");
					},
				},
			],
		},
		{
			label: "QPIP",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/payroll-qpip-earning/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/payroll-qpip-earning/setup");
					},
				},
			],
		},
		{
			label: "Federal Taxable",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/payroll-federal-taxable-earning/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/payroll-federal-taxable-earning/setup");
					},
				},
			],
		},
		{
			label: "Provincial Taxable",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/payroll-provincial-taxable-earning/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/payroll-provincial-taxable-earning/setup");
					},
				},
			],
		},
		{
			label: "Vocationable",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/payroll-vocational-earning/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/payroll-vocational-earning/setup");
					},
				},
			],
		},
	];

	return {
		EarningsRoutes: ArrayData,
	};
};
